(function(){
  "use strict";
  var money=function(c){try{return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(c):'₹'+(c/100).toFixed(0);}catch(e){return '₹'+(c/100).toFixed(0);}};
  var $=function(s,c){return (c||document).querySelector(s);};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var on=function(el,ev,fn){if(el)el.addEventListener(ev,fn);};

  /* ---------- Drawers / modals ---------- */
  function open(el){if(el){el.hidden=false;document.body.style.overflow='hidden';}}
  function close(el){if(el){el.hidden=true;document.body.style.overflow='';}}

  var mobileMenu=$('[data-mobile-menu]'),searchModal=$('[data-search-modal]'),cartDrawer=$('[data-cart-drawer]');

  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-menu-open]')){open(mobileMenu);}
    if(t.closest('[data-menu-close]')){close(mobileMenu);}
    if(t.closest('[data-search-open]')){e.preventDefault();open(searchModal);var i=$('input[type=search]',searchModal);if(i)setTimeout(function(){i.focus();},50);}
    if(t.closest('[data-search-close]')){close(searchModal);}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){close(mobileMenu);close(searchModal);close(cartDrawer);}});

  /* ---------- Cart ---------- */
  var cartType=document.body.getAttribute('data-cart-type');
  function updateCounts(n){$$('[data-cart-count]').forEach(function(el){el.textContent=n;});}
  function openCart(){open(cartDrawer);}

  function fetchCartState(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updateCounts(c.item_count);return c;});
  }

  // Add to cart (product form + quick add)
  function ajaxAdd(form){
    var btn=form.querySelector('[type=submit]');
    var orig=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.innerHTML='Adding...';}
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){return r.json();})
      .then(function(){return rebuildDrawer();})
      .then(function(){if(cartType==='drawer'){openCart();}else{window.location.href='/cart';}})
      .catch(function(){})
      .finally(function(){if(btn){btn.disabled=false;btn.innerHTML=orig;}});
  }

  function rebuildDrawer(){
    return fetchCartState().then(function(c){
      var body=$('[data-cart-body]');
      if(body){body.innerHTML=renderDrawer(c);}
      return c;
    });
  }

  function renderDrawer(c){
    if(!c||c.item_count===0){
      return '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary">Continue shopping</a></div>';
    }
    var rows=c.items.map(function(it,i){
      var line=i+1;
      var variant=(it.variant_title&&it.variant_title.indexOf('Default')===-1)?'<p class="cart-line__variant">'+it.variant_title+'</p>':'';
      var img=it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2')+'" alt="" width="72">':'';
      return '<li class="cart-line" data-cart-line="'+line+'">'+
        '<a href="'+it.url+'" class="cart-line__media">'+img+'</a>'+
        '<div class="cart-line__info"><a href="'+it.url+'" class="cart-line__title">'+it.product_title+'</a>'+variant+
        '<p class="cart-line__price">'+money(it.final_price)+'</p>'+
        '<div class="cart-line__actions"><div class="qty qty--sm">'+
        '<button data-qty-change data-line="'+line+'" data-qty="'+(it.quantity-1)+'">&minus;</button>'+
        '<span>'+it.quantity+'</span>'+
        '<button data-qty-change data-line="'+line+'" data-qty="'+(it.quantity+1)+'">+</button></div>'+
        '<button class="cart-line__remove" data-qty-change data-line="'+line+'" data-qty="0">Remove</button>'+
        '</div></div></li>';
    }).join('');
    return '<ul class="cart-line-items">'+rows+'</ul>'+
      '<div class="cart-drawer__foot"><div class="cart-drawer__subtotal"><span>Subtotal</span><strong>'+money(c.total_price)+'</strong></div>'+
      '<p class="cart-drawer__note">Taxes and shipping calculated at checkout</p>'+
      '<a href="/cart" class="btn btn--block btn--outline">View cart</a>'+
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn--block btn--primary">Checkout</button></form></div>';
  }

  function changeLine(line,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(line,10),quantity:parseInt(qty,10)})})
      .then(function(r){return r.json();})
      .then(function(c){
        updateCounts(c.item_count);
        var body=$('[data-cart-body]');if(body)body.innerHTML=renderDrawer(c);
        if(document.body.classList.contains('template-cart')){window.location.reload();}
      }).catch(function(){});
  }

  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f.matches('[data-product-form]')||f.matches('[data-quick-add-form]')){
      e.preventDefault();ajaxAdd(f);
    }
  });

  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-cart-open]');
    if(open&&cartType==='drawer'){e.preventDefault();rebuildDrawer().then(openCart);}
    if(e.target.closest('[data-cart-close]')){close(cartDrawer);}
    var qc=e.target.closest('[data-qty-change]');
    if(qc){e.preventDefault();changeLine(qc.getAttribute('data-line'),qc.getAttribute('data-qty'));}
  });

  // Cart page qty input direct change
  $$('[data-qty-input-line]').forEach(function(inp){
    on(inp,'change',function(){changeLine(inp.getAttribute('data-line'),inp.value);});
  });

  /* ---------- Product variants ---------- */
  (function(){
    var section=$('[data-product-section]');if(!section)return;
    var json=$('[data-variants-json]',section);
    var variants=[];try{variants=JSON.parse(json.textContent);}catch(e){}
    var select=$('[data-variant-select]',section);
    var form=$('[data-product-form]',section);
    var addBtn=$('[data-add-btn]',section);
    var addText=$('[data-add-text]',section);
    var priceWrap=$('[data-price]',section);
    var chosen=[];
    // init chosen from selected swatches
    $$('.product-option',section).forEach(function(opt,idx){
      var sel=opt.querySelector('.swatch.is-selected');
      chosen[idx]=sel?sel.getAttribute('data-value'):null;
    });

    $$('[data-option-value]',section).forEach(function(btn){
      on(btn,'click',function(){
        var idx=parseInt(btn.getAttribute('data-index'),10);
        var grp=btn.closest('.product-option');
        $$('.swatch',grp).forEach(function(b){b.classList.remove('is-selected');});
        btn.classList.add('is-selected');
        chosen[idx]=btn.getAttribute('data-value');
        var label=grp.querySelector('[data-option-selected]');if(label)label.textContent=chosen[idx];
        match();
      });
    });

    function match(){
      var v=variants.find(function(va){
        return chosen.every(function(c,i){return c==null||va.options[i]===c;});
      });
      if(!v)return;
      if(select){select.value=v.id;}
      // price
      if(priceWrap){
        var html='';
        if(v.compare_at_price&&v.compare_at_price>v.price){
          var disc=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price);
          html='<span class="price price--sale" data-price-current>'+money(v.price)+'</span> <s class="price price--compare">'+money(v.compare_at_price)+'</s> <span class="badge badge--sale">-'+disc+'%</span>';
        }else{
          html='<span class="price" data-price-current>'+money(v.price)+'</span>';
        }
        priceWrap.innerHTML=html;
      }
      if(addBtn){
        if(v.available){addBtn.disabled=false;if(addText)addText.textContent='Add to cart';}
        else{addBtn.disabled=true;if(addText)addText.textContent='Sold out';}
      }
      // update url
      try{var u=new URL(window.location);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}catch(e){}
    }

    // qty steppers
    var qi=$('[data-qty-input]',section);
    on($('[data-qty-inc]',section),'click',function(){if(qi)qi.value=parseInt(qi.value||1,10)+1;});
    on($('[data-qty-dec]',section),'click',function(){if(qi)qi.value=Math.max(1,parseInt(qi.value||1,10)-1);});

    // gallery
    $$('[data-thumb]',section).forEach(function(th){
      on(th,'click',function(){
        var id=th.getAttribute('data-thumb');
        $$('.product-gallery__thumb',section).forEach(function(t){t.classList.remove('is-active');});
        th.classList.add('is-active');
        $$('.product-gallery__slide',section).forEach(function(s){s.classList.toggle('is-active',s.getAttribute('data-media-id')===id);});
      });
    });
  })();

  /* ---------- Slideshow ---------- */
  $$('[data-slideshow]').forEach(function(root){
    var track=$('[data-slides]',root),slides=$$('[data-slide]',root),dots=$('[data-slide-dots]',root);
    if(slides.length<2)return;
    var i=0,timer;
    var sec=parseInt(root.getAttribute('data-autoplay')||'5',10);
    if(dots){slides.forEach(function(_,k){var b=document.createElement('button');if(k===0)b.className='is-active';b.addEventListener('click',function(){go(k);});dots.appendChild(b);});}
    function go(n){i=(n+slides.length)%slides.length;track.style.transform='translateX(-'+(i*100)+'%)';if(dots)$$('button',dots).forEach(function(d,k){d.classList.toggle('is-active',k===i);});}
    on($('[data-slide-next]',root),'click',function(){go(i+1);reset();});
    on($('[data-slide-prev]',root),'click',function(){go(i-1);reset();});
    function reset(){if(timer)clearInterval(timer);if(sec>0)timer=setInterval(function(){go(i+1);},sec*1000);}
    reset();
  });

  /* ---------- Collection sort + filters ---------- */
  (function(){
    var sort=$('[data-sort]');
    if(sort){on(sort,'change',function(){var u=new URL(window.location);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');window.location.href=u.toString();});}
    var filters=$('[data-filters]');
    on($('[data-filter-open]'),'click',function(){if(filters)filters.classList.add('is-open');document.body.style.overflow='hidden';});
    on($('[data-filter-close]'),'click',function(){if(filters)filters.classList.remove('is-open');document.body.style.overflow='';});
  })();

  /* ---------- Product recommendations (lazy) ---------- */
  $$('[data-recommendations][data-url]').forEach(function(el){
    fetch(el.getAttribute('data-url')).then(function(r){return r.text();}).then(function(html){
      var doc=document.createElement('div');doc.innerHTML=html;var sec=doc.querySelector('.product-recommendations');if(sec)el.innerHTML=sec.innerHTML;
    }).catch(function(){});
  });

  /* ---------- Wishlist (localStorage, stores full product info) ---------- */
  (function(){
    var KEY='vasthara_wishlist';
    function get(){try{var v=JSON.parse(localStorage.getItem(KEY));return Array.isArray(v)?v:[];}catch(e){return [];}}
    function set(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
    function ids(){return get().map(function(o){return String(o.id);});}
    function count(){var n=get().length;$$('[data-wishlist-count]').forEach(function(e){e.textContent=n;e.style.display=n>0?'':'none';});}
    function paint(){var w=ids();$$('[data-wishlist-toggle]').forEach(function(b){b.classList.toggle('is-active',w.indexOf(String(b.getAttribute('data-product-id')))>-1);});}
    function itemFrom(b){
      return {
        id:String(b.getAttribute('data-product-id')),
        handle:b.getAttribute('data-handle')||'',
        title:b.getAttribute('data-title')||'',
        url:b.getAttribute('data-url')||'#',
        image:b.getAttribute('data-image')||'',
        price:b.getAttribute('data-price')||''
      };
    }
    function render(){
      var box=$('[data-wishlist-page]'); if(!box) return;
      var w=get();
      if(!w.length){ box.innerHTML='<div class="wishlist-empty"><p>Your wishlist is empty.</p><a href="/collections/all" class="btn btn--primary">Continue shopping</a></div>'; return; }
      var html='<div class="product-grid wishlist-grid">';
      w.forEach(function(o){
        html+='<div class="product-card" data-wishlist-item="'+o.id+'">'+
          '<div class="product-card__media product-card__media--portrait">'+
            '<a href="'+o.url+'" class="product-card__link">'+(o.image?'<img class="product-card__img" src="'+o.image+'" alt="'+(o.title.replace(/"/g,"&quot;"))+'" loading="lazy" width="600" height="800">':'')+'</a>'+
            '<button class="product-card__wish is-active" data-wishlist-remove="'+o.id+'" aria-label="Remove from wishlist">&times;</button>'+
          '</div>'+
          '<div class="product-card__info">'+
            '<h3 class="product-card__title"><a href="'+o.url+'">'+o.title+'</a></h3>'+
            '<div class="product-card__price"><span class="price">'+o.price+'</span></div>'+
            '<a href="'+o.url+'" class="btn btn--block btn--dark" style="margin-top:.6rem">View product</a>'+
          '</div>'+
        '</div>';
      });
      html+='</div>';
      box.innerHTML=html;
    }
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-wishlist-toggle]');
      if(b){ e.preventDefault();
        var item=itemFrom(b);var w=get();var k=ids().indexOf(item.id);
        if(k>-1){w.splice(k,1);}else{w.push(item);}
        set(w);b.classList.toggle('is-active',k===-1);count();render();return;
      }
      var rm=e.target.closest('[data-wishlist-remove]');
      if(rm){ e.preventDefault();
        var id=String(rm.getAttribute('data-wishlist-remove'));
        var w=get().filter(function(o){return String(o.id)!==id;});
        set(w);count();paint();render();return;
      }
    });
    count();paint();render();
  })();

  fetchCartState();
})();

/* ===== Kalki-style header interactions (v2) ===== */
(function(){
  "use strict";
  var $=function(s,c){return (c||document).querySelector(s);};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};

  // Mega-menu tab switching (hover + click)
  $$('[data-mega-panel]').forEach(function(panel){
    var tabs=$$('.mega-panel__tab',panel), bodies=$$('.mega-panel__body',panel);
    function activate(i){
      tabs.forEach(function(t,k){t.classList.toggle('is-active',k===i);});
      bodies.forEach(function(b,k){b.classList.toggle('is-active',k===i);});
    }
    tabs.forEach(function(t,i){
      t.addEventListener('mouseenter',function(){activate(i);});
      t.addEventListener('click',function(){activate(i);});
    });
  });

  // Reset each mega panel to first tab when the parent item is left
  $$('[data-mega-item]').forEach(function(item){
    item.addEventListener('mouseleave',function(){
      var tabs=$$('.mega-panel__tab',item), bodies=$$('.mega-panel__body',item);
      tabs.forEach(function(t,k){t.classList.toggle('is-active',k===0);});
      bodies.forEach(function(b,k){b.classList.toggle('is-active',k===0);});
    });
  });

  // Announcement rotation
  $$('[data-announcement]').forEach(function(bar){
    var items=$$('.announcement-bar__item',bar);
    if(items.length<2)return;
    var i=0, sec=parseInt(bar.getAttribute('data-interval')||'3',10);
    setInterval(function(){
      items[i].classList.remove('is-active');
      i=(i+1)%items.length;
      items[i].classList.add('is-active');
    }, sec*1000);
  });

  // Animated search placeholder text
  var st=$('[data-typed]');
  if(st){
    var list=[];try{list=JSON.parse(st.getAttribute('data-typed'));}catch(e){}
    if(list.length>1){
      var idx=0;
      setInterval(function(){idx=(idx+1)%list.length;st.style.opacity='0';setTimeout(function(){st.textContent=list[idx];st.style.opacity='1';},250);},2600);
      st.style.transition='opacity .25s';
    }
  }

  // Mobile primary tabs
  var mtabs=$$('[data-mobile-tabs] .mobile-tab');
  var mbodies=$$('[data-mtabbody]');
  mtabs.forEach(function(tab){
    tab.addEventListener('click',function(){
      var i=tab.getAttribute('data-mtab');
      mtabs.forEach(function(t){t.classList.toggle('is-active',t===tab);});
      mbodies.forEach(function(b){b.classList.toggle('is-active',b.getAttribute('data-mtabbody')===i);});
    });
  });
})();
